import React from "react";

//Creates the total number of attempts and hints for double bar graph and table in quiz statistics
export function CreateQuizData(data, assignmentNum){
    if(data){
        let quizData = {
            attempts: [],
            hint: [],
            question: []
        };
        for(let i = 0; i < data[0].assignmentCompletion[assignmentNum].length; i++){
            quizData.question.push(i+1)
            quizData.attempts.push(0);
            quizData.hint.push(0)
        }

        for(let i = 0; i < data.length; i++) {
            let count = 0;

            for(let g = 0; g < data[i].assignmentCompletion[assignmentNum].length; g++){
                if(data[i].assignmentCompletion[assignmentNum][g] === 1){
                    count+=1
                }
            }

            //Checks to see if student finished all the questions in the assignment
            if(count/data[i].assignmentCompletion[assignmentNum].length*100 === 100){

                for(let n = 0; n < data[i].attempts[assignmentNum].length; n++){
                    quizData.attempts[n] += data[i].attempts[assignmentNum][n];
                    quizData.hint[n] += data[i].hint[assignmentNum][n];
                }

            }
        }
        return quizData;
    }

}
